import { defineComponent as t, openBlock as l, createBlock as r, unref as p, mergeProps as d, withCtx as h, createElementVNode as e } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const v = /* @__PURE__ */ t({
  name: "IconSmartphoneBroken",
  __name: "IconSmartphoneBroken",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const o = n;
    return (u, a) => (l(), r(p(m), d(o, { "view-box": "0 0 24 24" }), {
      default: h(() => [...a[0] || (a[0] = [
        e("path", { d: "M10.5 4.75a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3" }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M5.25 5.5A3.25 3.25 0 0 1 8.5 2.25h7a3.25 3.25 0 0 1 3.25 3.25V15a.75.75 0 0 1-1.28.53L13 11.06l-1.47 1.47a.75.75 0 0 1-1.06 0l-5-5A.75.75 0 0 1 5.25 7V5.5M8.5 3.75A1.75 1.75 0 0 0 6.75 5.5v1.19L11 10.94l1.47-1.47a.75.75 0 0 1 1.06 0l3.72 3.72V5.5a1.75 1.75 0 0 0-1.75-1.75h-7",
          "clip-rule": "evenodd"
        }, null, -1),
        e("path", { d: "M6.75 10.5v8a1.75 1.75 0 0 0 1.75 1.75h7a1.75 1.75 0 0 0 1.75-1.75v-1a.75.75 0 0 1 1.5 0v1a3.25 3.25 0 0 1-3.25 3.25h-7a3.25 3.25 0 0 1-3.25-3.25v-8a.75.75 0 0 1 1.5 0" }, null, -1),
        e("path", { d: "M12 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  v as default
};
